import React, { useEffect, useState, useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Container, Grid, Button } from 'semantic-ui-react';
import { useCookies } from 'react-cookie';
import Link from '../Link';
import alertIcon from '../../assets/images/icon-alert.svg';
import { LargeMonitorContext } from '../../context';
import classNames from 'classnames';

function NotificationBar() {
  const largeMonitorContext = useContext(LargeMonitorContext);
  const showCookie = 'citipower-show-notification-bar';
  const cookieAge = 60 * 60 * 24; // seconds in a day
  const cookieOptions = { path: '/', maxAge: cookieAge };
  const [cookies, setCookie, removeCookie] = useCookies([
    showCookie
  ]);

  const data = useStaticQuery(graphql`
    query notificationBarQuery {
      wp {
        acfOptionsNotificationBar {
          notificationBarOptions {
            showNotificationBar
            notificationBarDate
            notificationBar {
              messageContent {
                title
                text
              }
              link {
                url
                title
                target
              }
            }
          }
        }
      }
    }
  `);

  let {
    wp: {
      acfOptionsNotificationBar: {
        notificationBarOptions: {
          showNotificationBar,
          notificationBarDate,
          notificationBar: {
            link,
            messageContent: { text, title },
          },
        },
      },
    },
  } = data;

  useEffect(() => {
    if (showNotificationBar && !cookies['citipower-show-notification-bar']) {
      setCookie(
        showCookie,
        { show: true, date: notificationBarDate },
        cookieOptions
      );
    } else if (
      showNotificationBar &&
      cookies['citipower-show-notification-bar']
    ) {
      if (
        cookies['citipower-show-notification-bar']['date'] !==
        notificationBarDate
      ) {
        removeCookie(showCookie);
        setCookie(
          showCookie,
          { show: true, date: notificationBarDate },
          cookieOptions
        );
      }
    }
  }, [showCookie]);

  const [display, setDisplay] = useState(false);
  useEffect(() => {
    // add this delay to the render to prevent flashing
    if (
      cookies['citipower-show-notification-bar'] &&
      cookies['citipower-show-notification-bar']['show']
    ) {
      let delayTimer = setTimeout(() => setDisplay(true), 1000);
      return () => {
        clearTimeout(delayTimer);
      };
    } else {
      setDisplay(false);
    }
  }, [cookies['citipower-show-notification-bar']]);

  function handleNotificationClose() {
    setCookie(
      showCookie,
      { show: false, date: notificationBarDate },
      cookieOptions
    );
  }

  // check if cookie is set, if not check if prop coming in wants it to be shown
  return display === true ? (
    <Container fluid className={`notification-bar__container`}>
      <Container>
        <Grid className="notification-bar__wrapper">
          <Grid.Row className="notification-bar__row">
            <Grid.Column
              mobile={12}
              tablet={7}
              computer={largeMonitorContext ? 8 : 7}
              largeScreen={7}
              className="notification-bar__content-column-wrapper"
            >
              <div className="notification-bar__content-column">
                <img
                  src={alertIcon}
                  alt="Alert Icon"
                  className="notification-bar__alert-icon"
                />
                <div className="notification-bar__content-wrapper">
                  <p className="notification-bar__title">{title}</p>
                  <p className="notification-bar__content">{text}</p>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column
              mobile={12}
              tablet={5}
              computer={largeMonitorContext ? 4 : 5}
              largeScreen={5}
              id="notification-bar__actions-column-wrapper"
            >
              <div
                className={classNames('notification-bar__actions-column', {
                  'notification-bar__one-button': !link,
                })}
              >
                {link && (
                  <Link
                    to={link.url}
                    // TODO: should target be blank by default?
                    target={link.target ? link.target : '_blank'}
                    className="notification-bar__link no-decoration"
                  >
                    {link.title}
                  </Link>
                )}
                <Button
                  className="cp-button--outline notification-bar__close-button"
                  onClick={handleNotificationClose}
                >
                  Close
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Container>
  ) : null;
}

export default NotificationBar;
